import Login from '../views/app/Login.vue'
import Logout from '../views/app/Logout.vue'

export default [{
    path: '/login',
    name: 'app/login',
    component: Login,
    meta: { title: 'Anmelden' }
}, {
    path: '/logout',
    name: 'app/logout',
    component: Logout
}]
